import { render, staticRenderFns } from "./DocumentTemplatePrescriptionLetterPreview.vue?vue&type=template&id=c3df9d36&scoped=true&lang=pug&"
import script from "./DocumentTemplatePrescriptionLetterPreview.vue?vue&type=script&lang=js&"
export * from "./DocumentTemplatePrescriptionLetterPreview.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTemplatePrescriptionLetterPreview.vue?vue&type=style&index=0&id=c3df9d36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3df9d36",
  null
  
)

export default component.exports